module.exports = __webpack_public_path__ + "img/Digital eye.b0e54365.png";